<template>
  <b-link
    v-b-tooltip.hover
    :title="tooltip"
    :to="{ name: 'membership', query: { upgrade: 'suppliers_visible_from_start' } }"
    class="membership-lock-chip"
    @click.stop
  >
    <feather-icon
      icon="LockIcon"
      :size="size"
    />
    <span
      v-if="label"
      class="membership-lock-chip__label"
    >{{ label }}</span>
  </b-link>
</template>

<script>
import { BLink, VBTooltip } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    label: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '14',
    },
    planName: {
      type: String,
      default: '',
    },
  },

  computed: {
    tooltip() {
      const plan = this.planName || 'de paga'

      return `El nombre de este proveedor está oculto con tu plan actual. Contrata el plan ${plan} para verlo.`
    },
  },
}
</script>

<style lang="scss" scoped>
.membership-lock-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  margin-left: 0.4rem;
  padding: 0.1rem 0.35rem;
  border-radius: 0.35rem;
  color: #b8860b;
  background: rgba(255, 193, 7, 0.16);
  vertical-align: middle;
  line-height: 1;

  &:hover {
    background: rgba(255, 193, 7, 0.3);
    color: #8a6508;
  }
}

.membership-lock-chip__label {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
</style>
